import _ from '@/utils/lodash-optimized'

export const makeCancelable = promise => {
  let hasCanceled_ = false

  let cancelError = new Error('CancelError')
  cancelError.isCanceled = true

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val => hasCanceled_ ? reject(cancelError) : resolve(val))
    promise.catch(error => hasCanceled_ ? reject(cancelError) : reject(error))
  })

  return {
    promise: wrappedPromise,
    cancel () {
      hasCanceled_ = true
    }
  }
}

export const reasonable = params => v => {
  const { message, min, max } = params
  const value = _.toString(v)
  if (_.isEmpty(value)) {
    return null
  }
  if (value.match(/^\d+$/)) {
    const parsed = _.parseInt(value)
    if (parsed >= min && parsed <= max) {
      return null
    }
  }
  return message || `Please provide integer from ${min} to ${max}`
}

export const reasonableDecimal = params => v => {
  const { message, min, max } = params
  const value = _.toString(v)
  if (_.isEmpty(value)) {
    return null
  }
  if (value.match(/^\s*-?\d+(\.\d{1,2})?\s*$/)) {
    if (value >= min && value <= max) {
      return null
    }
  }
  return message || `Please provide a number from ${min} to ${max} (2 decimal places allowed)`
}
